import React, { useMemo } from 'react';
import { toggleQuickTasks } from 'store/order/quickForms/quickFormsSlice';
import { useAppSelector, useAppDispatch } from 'store/store';
import { TasksContainer } from 'components/tasks/TasksContainer';
import { MobileDialog } from './MobileDialog';

interface ITaskListContainerProps {}

export const QuickTaskContainer: React.FC<ITaskListContainerProps> = () => {
  const { isOpenQuickTasks } = useAppSelector((root) => root.order.quickFormsSlice);
  const dispatch = useAppDispatch();

  const body = useMemo(() => {
    return ({ dialogControls, expanded }: { dialogControls: React.ReactNode; expanded: boolean }) => (
      <TasksContainer dialogControls={dialogControls} maxCount={expanded ? undefined : 5} />
    );
  }, []);

  return (
    <MobileDialog title={'Tasks'} isOpen={isOpenQuickTasks} onClose={() => dispatch(toggleQuickTasks())} Body={body} />
  );
};
